import { CCBlock} from "./CCBlock";

export class CCEnrollment {
    ccEnrollmentId: number;
    enrollmentDate: string;
    examCredit: number;
    ccBlocks: Array<CCBlock>;
    patientSafetyCompletedYear: number;
    currentCCBlock: CCBlock;
    isBehindCurrentBlock: boolean;
    enrollmentCertificates:  Array<EnrollmentCertificate>;
    activeEnrollmentCertificates:  Array<EnrollmentCertificate>;
    futureEnrollmentCertificates:  Array<EnrollmentCertificate>;
}

export enum CCAssessmentType{
    Article = 1,
    Exam = 2,
    Other = 3
    
}

export class CCEnrollmentsModel {
    currentCCEnrollmentId?: number;
    ccEnrollments: Array<CCEnrollment>;
    hasCCEnrollmentHistory: boolean;
}

export class EnrollmentCertificate{
    cCEnrollmentCertificateId: number;
    certificateId: number;
    certification_Key: number;
    certificationName: string;
    certificationGeneration: number;
    isABCCEligible: boolean;
    isEnrolled: string;
    enrollmentStartDate: string;
    enrollmentEndDate?: string;
    ccAssessmentType: CCAssessmentType;
    ccAssessmentAttestationDate: string;
    lastArticleAssessmentEnrolledDate: string;
}